<template lang="pug">
    layout

        // Main title
        title-component(
            slot="title"
            type="h2"
            :title="$t('landingPages.create.title')"
        )

        // Login form
        landing-page-form
</template>

<script>
    import Layout from '../../Layout/Layout';
    import LandingPageForm from '../Manage/LandingPageForm';
    import Title from '~components/Title';

    export default {
        components: {
            Layout,
            LandingPageForm,
            TitleComponent: Title
        }
    };
</script>
